import { render, staticRenderFns } from "./GameCardContainer.vue?vue&type=template&id=a612e014&scoped=true"
import script from "./GameCardContainer.vue?vue&type=script&lang=js"
export * from "./GameCardContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a612e014",
  null
  
)

export default component.exports